import { render, staticRenderFns } from "./hand-thumbs-up.vue?vue&type=template&id=5c95105c&"
import script from "./hand-thumbs-up.vue?vue&type=script&lang=js&"
export * from "./hand-thumbs-up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c95105c')) {
      api.createRecord('5c95105c', component.options)
    } else {
      api.reload('5c95105c', component.options)
    }
    module.hot.accept("./hand-thumbs-up.vue?vue&type=template&id=5c95105c&", function () {
      api.rerender('5c95105c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/hand-thumbs-up.vue"
export default component.exports